import React from 'react';

import { IconButton, styled } from '@mui/material';
import { useTheme } from '@mui/styles';

import HelpCircle from 'components/SvgComponents/icons/HelpCircle';
import HelpCircleFill from 'components/SvgComponents/icons/HelpCircleFill';
import { LOGO_TOOLBAR_HEIGHT, LOGO_TOOLBAR_WIDTH } from 'containers/NavigationBar/constants';
import { useColorMode } from 'contexts/ColorModeProvider';
import { useFeatureFlags } from 'contexts/FeatureFlagsProvider';
import Analytics from 'utils/Analytics';
import { colorTheme } from 'utils/constants';

const IconButton_HelpCenter = styled(IconButton)(() => ({
  '& .helpCenterSvgFill': {
    opacity: 0,
    position: 'absolute',
  },
  '&:hover .helpCenterSvg': {
    opacity: 0,
  },
  '&:hover .helpCenterSvgFill': {
    opacity: 1,
  },
}));

const HelpCenter = () => {
  const featureFlags = useFeatureFlags();
  const theme = useTheme();
  const { mode } = useColorMode();
  const isDarkMode = mode === colorTheme.dark;

  const handleClickHelpCenter = () => {
    Analytics.track('onboarding_help_center_opened');
  };

  return (
    <IconButton_HelpCenter
      component="a"
      href={featureFlags?.web_help_center_link || '#'}
      target="_blank"
      onClick={handleClickHelpCenter}
    >
      <HelpCircle
        width={LOGO_TOOLBAR_WIDTH}
        height={LOGO_TOOLBAR_HEIGHT}
        className={isDarkMode ? 'helpCenterSvgFill' : 'helpCenterSvg'}
        fill={isDarkMode ? theme.palette.text.white : theme.palette.text.primary}
      />
      <HelpCircleFill
        width={LOGO_TOOLBAR_WIDTH}
        height={LOGO_TOOLBAR_HEIGHT}
        className={isDarkMode ? 'helpCenterSvg' : 'helpCenterSvgFill'}
        color={isDarkMode ? theme.palette.background.white : theme.palette.text.primary}
        fill={theme.palette.background.white}
      />
    </IconButton_HelpCenter>
  );
};

export default React.memo(HelpCenter);
